import noop from 'lodash/noop';

import LikertScale from '@/modules/user-survey/components/LikertScale';
import {
  QuestionEntityEditorProps,
  SurveyQuestionsField,
} from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/types';
import { QuestionTypeEnum } from '@/types/schema';

import { getCustomRatingLabels } from '../../utils';

const LikertField: SurveyQuestionsField = {
  type: QuestionTypeEnum.Likert,
  Editor: ({ question }: QuestionEntityEditorProps) => (
    <LikertScale ratingLabels={getCustomRatingLabels(question)} onChange={noop} />
  ),
};

export default LikertField;
